import {
  BieHistoricalWorkbenchModel,
  HistoricalDatasetRow,
  HistoricalFactRow,
  HistoricalImportRow,
  HistoricalIntegrityIssue,
  HistoricalGapRow,
} from './bieHistorical.models';

const n = (value: unknown, fallback = 0): number => {
  const result = Number(value);
  return Number.isFinite(result) ? result : fallback;
};

const b = (value: unknown): boolean =>
  value === true || value === 1 || value === '1' || value === 'true';

export const normalizeHistoricalImportRow = (r: any): HistoricalImportRow => ({
  rid: n(r.rid ?? r.recid ?? r.id),
  rix: r.rix ?? r.recix ?? undefined,
  code: r.shc ?? r.shortcode ?? '',
  name: r.nam ?? r.recname ?? '',
  description: r.dsc ?? r.description ?? '',
  planningcycleid: r.pci ?? r.planningcycleid ?? null,
  historicaldatasetid: r.hdi ?? r.historicaldatasetid ?? null,
  sourceid: r.soi ?? r.sourceid ?? null,
  sourcecode: r.soc ?? r.sourcecode ?? '',
  sourcename: r.son ?? r.sourcename ?? '',
  scenarioid: r.sci ?? r.scenarioid ?? null,
  scenariocode: r.scc ?? r.scenariocode ?? '',
  scenarioname: r.scn ?? r.scenarioname ?? '',
  trackid: r.tri ?? r.trackid ?? '',
  filename: r.fnm ?? r.fln ?? r.filename ?? r.nam ?? '',
  importdate: r.dcd ?? r.importdate ?? r.created ?? null,
  recordcount: n(r.trc ?? r.recordcount),
  validcount: n(r.vrc ?? r.validcount),
  warningcount: n(r.wrc ?? r.warningcount),
  errorcount: n(r.crc ?? r.errorcount),
  failedcount: n(r.frc ?? r.failedcount),
  statecode: r.ssc ?? r.statecode ?? '',
  statename: r.ssn ?? r.statename ?? '',
  status: n(r.ast ?? r.sts ?? r.status, 1),
  validationmessage: r.vmg ?? r.validationmessage ?? '',

  matrixexisting: b(r.mex ?? r.matrixexisting ?? r.existing),
  matrixstatuscode: r.msc ?? r.matrixstatuscode ?? '',
  matrixstatusname: r.msn ?? r.matrixstatusname ?? '',
  resolutioncode: r.rsc ?? r.resolutioncode ?? '',
  resolutionname: r.rsn ?? r.resolutionname ?? '',
  editable: b(r.edt ?? r.editable),
  existingdatasetid: r.ehi ?? r.existingdatasetid ?? null,
  existingdatasetcode: r.ehc ?? r.existingdatasetcode ?? '',
  existingdatasetname: r.ehn ?? r.existingdatasetname ?? '',
  gapclasscode: r.gcc ?? r.gapclasscode ?? '',
  gapclassname: r.gcn ?? r.gapclassname ?? '',

  raw: r,
});

export const normalizeHistoricalDatasetRow = (r: any): HistoricalDatasetRow => ({
  rid: n(r.rid ?? r.recid ?? r.id),
  rix: r.rix ?? r.recix ?? undefined,
  code: r.shc ?? r.shortcode ?? '',
  name: r.nam ?? r.recname ?? '',
  statecode: r.ssc ?? r.statecode ?? '',
  statename: r.ssn ?? r.statename ?? '',
  loadsessionid: r.lsi ?? r.loadsessionid ?? null,
  loadsessioncode: r.lsc ?? r.loadsessioncode ?? '',
  loadsessionname: r.lsn ?? r.loadsessionname ?? '',
  planningcycleid: r.pci ?? r.planningcycleid ?? null,
  planningcyclecode: r.pcc ?? r.planningcyclecode ?? '',
  planningcyclename: r.pcn ?? r.planningcyclename ?? '',
  importid: r.imi ?? r.importid ?? null,
  importcode: r.imc ?? r.importcode ?? '',
  importname: r.imn ?? r.importname ?? '',
  filename: r.fnm ?? r.fln ?? r.filename ?? '',
  sourceid: r.soi ?? r.sourceid ?? null,
  sourcecode: r.soc ?? r.sourcecode ?? '',
  sourcename: r.son ?? r.sourcename ?? '',
  coveragefrom: r.cvf ?? r.coveragefrom ?? null,
  coverageto: r.cvt ?? r.coverageto ?? null,
  factcount: n(r.fct ?? r.factcount),
  activefactcount: n(r.afc ?? r.activefactcount),
  publishedat: r.pat ?? r.publishedat ?? null,
  publishedby: r.pby ?? r.publishedby ?? null,
  raw: r,
});

export const normalizeHistoricalFactRow = (r: any): HistoricalFactRow => ({
  rid: r.rid ?? r.recid ?? r.id ?? r.rix ?? r.recix,
  rix: r.rix ?? r.recix ?? undefined,
  stamp: r.stp ?? r.stamp ?? undefined,
  importid: r.imi ?? r.importid ?? null,
  planningcycleid: r.pci ?? r.planningcycleid ?? null,
  historicaldatasetid: r.hdi ?? r.historicaldatasetid ?? null,
  trackid: r.tri ?? r.trackid ?? '',
  metriccode: r.mtc ?? r.metriccode ?? r.drc ?? '',
  metricname: r.mtn ?? r.metricname ?? r.drn ?? '',
  productcode: r.prc ?? r.productcode ?? r.enc ?? '',
  productname: r.prn ?? r.productname ?? r.enn ?? '',
  locationcode: r.loc ?? r.lcc ?? r.locationcode ?? '',
  locationname: r.lon ?? r.lcn ?? r.locationname ?? '',
  periodcode: r.pec ?? r.periodcode ?? r.psh ?? '',
  periodname: r.pen ?? r.periodname ?? '',
  fiscalyear: r.fyr ?? r.fiscalyear ?? '',
  unitcode: r.unc ?? r.unitcode ?? '',
  quantity: n(r.qty ?? r.quantity),
  unitprice: n(r.upr ?? r.unitprice),
  amount: n(r.amt ?? r.amount),
  sourcecode: r.soc ?? r.sourcecode ?? '',
  statecode: r.ssc ?? r.statecode ?? '',
  statename: r.ssn ?? r.statename ?? '',
  remarks: r.rmk ?? r.remarks ?? r.dsc ?? '',
  status: n(r.ast ?? r.sts ?? r.status, 1),
  validationmessage: r.vmg ?? r.validationmessage ?? '',

  matrixexisting: b(r.mex ?? r.matrixexisting ?? r.existing),
  matrixstatuscode: r.msc ?? r.matrixstatuscode ?? '',
  matrixstatusname: r.msn ?? r.matrixstatusname ?? '',
  resolutioncode: r.rsc ?? r.resolutioncode ?? '',
  resolutionname: r.rsn ?? r.resolutionname ?? '',
  editable: b(r.edt ?? r.editable),
  existingdatasetid: r.ehi ?? r.existingdatasetid ?? null,
  existingdatasetcode: r.ehc ?? r.existingdatasetcode ?? '',
  existingdatasetname: r.ehn ?? r.existingdatasetname ?? '',
  gapclasscode: r.gcc ?? r.gapclasscode ?? '',
  gapclassname: r.gcn ?? r.gapclassname ?? '',

  raw: r,
});


export const normalizeHistoricalIntegrityIssue = (r: any): HistoricalIntegrityIssue => ({
  rid: r.rid ?? r.recid ?? r.id ?? r.rix ?? r.recix,
  rix: r.rix ?? r.recix ?? undefined,
  issuecode: r.isc ?? r.issuecode ?? r.shc ?? '',
  issuename: r.isn ?? r.issuename ?? r.nam ?? '',
  severitycode: (r.svc ?? r.severitycode ?? 'INFO') as HistoricalIntegrityIssue['severitycode'],
  severityname: r.svn ?? r.severityname ?? r.svc ?? r.severitycode ?? 'Information',
  categorycode: r.ctc ?? r.categorycode ?? '',
  categoryname: r.ctn ?? r.categoryname ?? r.ctc ?? r.categorycode ?? '',
  metriccode: r.mtc ?? r.metriccode ?? '',
  metricname: r.mtn ?? r.metricname ?? '',
  productcode: r.prc ?? r.productcode ?? '',
  productname: r.prn ?? r.productname ?? '',
  locationcode: r.loc ?? r.lcc ?? r.locationcode ?? '',
  locationname: r.lon ?? r.lcn ?? r.locationname ?? '',
  periodcode: r.pec ?? r.periodcode ?? '',
  periodname: r.pen ?? r.periodname ?? '',
  fiscalyear: r.fyr ?? r.fiscalyear ?? '',
  sourcecode: r.soc ?? r.sourcecode ?? '',
  importid: r.imi ?? r.importid ?? null,
  factid: r.fai ?? r.factid ?? null,
  message: r.msg ?? r.message ?? r.dsc ?? '',
  resolutionhint: r.rsh ?? r.resolutionhint ?? r.rmk ?? '',
  resolved: b(r.rsv ?? r.resolved),
  created: r.dcd ?? r.created ?? null,
  raw: r,
});

export const normalizeHistoricalWorkbench = (r: any): BieHistoricalWorkbenchModel => {
  const context = r.context ?? r.ctx ?? {};
  const summary = r.summary ?? r.smy ?? {};
  const readiness = r.readiness ?? r.rdy ?? {};
  const actions = r.actions ?? r.act ?? {};
  const coverage = r.coverage ?? r.cvg ?? {};
  const validation = r.validation ?? r.vld ?? {};
  const imports = r.imports ?? r.imp ?? [];
  const datasets = r.datasets ?? r.dts ?? [];

  return {
    context: {
      planningcycleid: n(context.planningcycleid ?? context.rid ?? context.pci),
      planningcycleix: context.planningcycleix ?? context.rix ?? context.pix,
      planningcyclecode: context.planningcyclecode ?? context.code ?? context.shc ?? '',
      planningcyclename: context.planningcyclename ?? context.name ?? context.nam ?? '',
      budgetperiodid: context.budgetperiodid ?? context.bpi ?? null,
      budgetperiodcode: context.budgetperiodcode ?? context.bpc ?? '',
      budgetperiodname: context.budgetperiodname ?? context.bpn ?? '',
      fiscalyear: context.fiscalyear ?? context.fyr ?? '',
      phasecode: context.phasecode ?? context.phc ?? 'HISTORICAL_DATA',
      phasename: context.phasename ?? context.phn ?? '',
      statecode: context.statecode ?? context.stc ?? '',
      statename: context.statename ?? context.stn ?? '',
      historicaldatasetid: context.historicaldatasetid ?? context.hdi ?? null,
      historicaldatasetix: context.historicaldatasetix ?? context.hdx,
      historicaldatasetcode: context.historicaldatasetcode ?? context.hdc ?? '',
      historicaldatasetname: context.historicaldatasetname ?? context.hdn ?? '',
      coveragestartdate: context.coveragestartdate ?? context.csd ?? null,
      coverageenddate: context.coverageenddate ?? context.ced ?? null,
      allowedhistoricalyears: Array.isArray(context.allowedhistoricalyears ?? context.ahy)
        ? (context.allowedhistoricalyears ?? context.ahy).map(String)
        : [],
    },
    summary: {
      importcount: n(summary.importcount ?? summary.imc),
      factcount: n(summary.factcount ?? summary.fac),
      validcount: n(summary.validcount ?? summary.vac),
      warningcount: n(summary.warningcount ?? summary.wac),
      errorcount: n(summary.errorcount ?? summary.erc),
      failedcount: n(summary.failedcount ?? summary.flc),
      blockingcount: n(summary.blockingcount ?? summary.blc),
      datasetcount: n(summary.datasetcount ?? summary.dtc),
      metriccount: n(summary.metriccount ?? summary.mtc),
      periodcount: n(summary.periodcount ?? summary.prc),
      productcount: n(summary.productcount ?? summary.pdc),
      entitycount: n(summary.entitycount ?? summary.enc),
      locationcount: n(summary.locationcount ?? summary.loc),
    },
    readiness: {
      complete: b(readiness.complete ?? readiness.cmp),
      blockingcount: n(readiness.blockingcount ?? readiness.blc),
      warningcount: n(readiness.warningcount ?? readiness.wac),
      canvalidate: b(readiness.canvalidate ?? readiness.cvl),
      cancomplete: b(readiness.cancomplete ?? readiness.cmpa),
      canexit: b(readiness.canexit ?? readiness.ext),
    },
    actions: {
      canrefresh: actions.canrefresh === undefined ? true : b(actions.canrefresh),
      canimport: b(actions.canimport ?? actions.imp),
      canmanualentry: b(actions.canmanualentry ?? actions.man),
      canvalidate: b(actions.canvalidate ?? actions.val),
      cancomplete: b(actions.cancomplete ?? actions.cmp),
      canexit: b(actions.canexit ?? actions.ext),
      nextpage: actions.nextpage ?? actions.nxp ?? 'determinantbudget',
    },
    coverage: {
      expectedyears: n(coverage.expectedyears ?? coverage.eyr),
      coveredyears: n(coverage.coveredyears ?? coverage.cyr),
      expectedperiods: n(coverage.expectedperiods ?? coverage.epe),
      coveredperiods: n(coverage.coveredperiods ?? coverage.cpe),
      expectedmetrics: n(coverage.expectedmetrics ?? coverage.emt),
      coveredmetrics: n(coverage.coveredmetrics ?? coverage.cmt),
      expectedproducts: n(coverage.expectedproducts ?? coverage.epr),
      coveredproducts: n(coverage.coveredproducts ?? coverage.cpr),
      missingyearcount: n(coverage.missingyearcount ?? coverage.myc),
      missingperiodcount: n(coverage.missingperiodcount ?? coverage.mpc),
      missingmetriccount: n(coverage.missingmetriccount ?? coverage.mmc),
      missingproductcount: n(coverage.missingproductcount ?? coverage.mrc),
      duplicatecount: n(coverage.duplicatecount ?? coverage.dpc),
      unresolvedcount: n(coverage.unresolvedcount ?? coverage.urc),
      invalidvaluecount: n(coverage.invalidvaluecount ?? coverage.ivc),
      missingunitcount: n(coverage.missingunitcount ?? coverage.muc),
      orphanfactcount: n(coverage.orphanfactcount ?? coverage.ofc),
    },
    validation: {
      validationrunid: validation.validationrunid ?? validation.rid ?? validation.vri ?? null,
      validationrunix: validation.validationrunix ?? validation.rix ?? validation.vrx,
      statecode: validation.statecode ?? validation.ssc ?? '',
      statename: validation.statename ?? validation.ssn ?? '',
      validatedby: validation.validatedby ?? validation.vbn ?? '',
      validatedat: validation.validatedat ?? validation.vat ?? null,
      blockingcount: n(validation.blockingcount ?? validation.blc),
      warningcount: n(validation.warningcount ?? validation.wac),
      infocount: n(validation.infocount ?? validation.ifc),
      issuecount: n(validation.issuecount ?? validation.isc),
    },
    imports: Array.isArray(imports) ? imports.map(normalizeHistoricalImportRow) : [],
    datasets: Array.isArray(datasets) ? datasets.map(normalizeHistoricalDatasetRow) : [],
  };
};


export const normalizeHistoricalGapRow = (r: any): HistoricalGapRow => ({
  gapkey: String(r.gapkey ?? r.gpk ?? ''),
  fiscalyear: String(r.fiscalyear ?? r.fyr ?? ''),
  metriccode: String(r.metriccode ?? r.mtc ?? ''),
  metricname: String(r.metricname ?? r.mtn ?? ''),
  periodcode: String(r.periodcode ?? r.pec ?? ''),
  periodname: String(r.periodname ?? r.pen ?? ''),
  periodstartdate: r.periodstartdate ?? r.psd ?? null,
  productcode: String(r.productcode ?? r.prc ?? ''),
  productname: String(r.productname ?? r.prn ?? ''),
  locationcode: String(r.locationcode ?? r.lcc ?? r.loc ?? ''),
  locationname: String(r.locationname ?? r.lcn ?? r.lon ?? ''),
  entitycode: String(r.entitycode ?? r.enc ?? ''),
  entityname: String(r.entityname ?? r.enn ?? ''),
  accountcode: String(r.accountcode ?? r.acc ?? ''),
  accountname: String(r.accountname ?? r.acn ?? ''),
  unitcode: String(r.unitcode ?? r.unc ?? ''),
  matrixstatuscode: String(r.matrixstatuscode ?? r.msc ?? ''),
  matrixstatusname: String(r.matrixstatusname ?? r.msn ?? ''),
  gapclassname: String(r.gapclassname ?? r.gcn ?? ''),
  resolutioncode: String(r.resolutioncode ?? r.rsc ?? ''),
  resolutionname: String(r.resolutionname ?? r.rsn ?? ''),
  raw: r,
});
